<template>
  <component :is="componentName" v-bind="$props"></component>
</template>

<script>
  import * as notificationTexts from './notification-texts';
  import NotificationText from './NotificationText';
  import {props as notificationProps} from './notification-utils';

  export default {
    name: 'Notification',

    components: {
      ...notificationTexts,
      NotificationText
    },

    props: notificationProps,

    computed: {
      componentName() {
        // dash-case to PascalCase
        let name = this.notification?.type
          .split('-')
          .map((a) => a[0].toUpperCase() + a.substring(1))
          .join('');

        if (notificationTexts[name]) {
          return name;
        }
        return NotificationText;
      }
    }
  };
</script>
